﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../../components/application"
import { DropdownEntry } from "../../controls/dropdownbox";
import { IDisposable } from "../../interfaces/general";
import { TranslationService } from "../../services/TranslationService";
import { Status } from "../../models/serviceCase";

@Component({
    module: FIQAssist,
    selector: "statuschecklistcombo",
    template: `
            <checklistcombo value-sumbit="$ctrl.passValueSubmit(selected)" read-only="$ctrl.readOnly" onselectionchanged="$ctrl.statusesselected(selected)"
                items="$ctrl.items" showAllOption="true" all-subset="$ctrl.activeSubset"
                all-item-text="$ctrl.ACTIVE_STATUSES | translate"
                all-selected-text="$ctrl.ALL_STATUSES_SELECTED | translate "
                subset-selected-text="$ctrl.ACTIVE_STATUSES_SELECTED | translate"
                multiple-selected-text="$ctrl.MULTIPLE_STATUSES_SELECTED | translate"
                none-selected-text="''" checked="$ctrl.statuses" show-clear="{{$ctrl.showClear}}"
                ></checklistcombo>`
})
class StatusChecklistCombo implements IComponent {
    @Input() public readOnly: boolean;
    private _statuses: { key: Status, text: string }[];
    private initialized: boolean = false;
    private ACTIVE_STATUSES = "ACTIVE_STATUSES"
    private ALL_STATUSES_SELECTED = "ALL_STATUSES_SELECTED"
    private ACTIVE_STATUSES_SELECTED = "ACTIVE_STATUSES_SELECTED"
    private MULTIPLE_STATUSES_SELECTED = "MULTIPLE_STATUSES_SELECTED"

    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject() private translationService: TranslationService
    ) { }

    $onInit() {
        this.initialized = true;
        this.items = <{ key: Status, text: string }[]>[
            { key: 'open', text: 'OPEN' },
            { key: 'inProgress', text: 'INPROGRESS' },
            { key: 'waitingForUat', text: 'WAITINGFORUAT' },
            { key: 'readyForUat', text: 'READYFORUAT' },
            { key: 'approved', text: 'APPROVED' },
            { key: 'rework', text: 'REWORK' },
            { key: 'waitingForRelease', text: 'WAITINGFORRELEASE' },
            { key: 'delivered', text: 'DELIVERED' },
            { key: 'handled', text: 'HANDLED' },
            { key: 'cancelled', text: 'CANCELLED' },
            { key: 'closed', text: 'CLOSED' },
            { key: 'analysis', text: 'ANALYSIS' },
            { key: 'parked', text: 'PARKED' }].sort((a, b) => a.key > b.key ? 1 : -1);
        this.translateItems();
    }

    private async translateItems() {
        await this.translationService.onLoaded;
        this.items = this.items.map(i => { i.text = this.translationService.Translate(i.text); return i; }).sort((a, b) => a.text > b.text ? 1 : -1);
    }

    private activeSubset: Status[] = ['open', 'inProgress', 'waitingForUat', 'readyForUat', 'approved', 'rework', 'waitingForRelease', 'analysis', 'parked'];

    @Input()
    public get statuses(): { key: Status, text: string }[] {
        return this._statuses;
    }
    public set statuses(statuses: { key: Status, text: string }[]) {
        this._statuses = statuses;
    }
    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }
    private items: { key: Status, text: string }[];

    public statusesselected(selected: any[]) {
        this.statuses = selected;
        this.onStatusesChanged({ statuses: this.statuses });
    }

    @Output() public onStatusesChanged: (args: { statuses: any[] }) => void;
    @Output() public valueSubmit: OutputArgs<{ statuses: { key: string, text: string }[] }>;
    public passValueSubmit(selected: any[]) {
        this.statuses = selected;
        if (this.valueSubmit) this.valueSubmit({ statuses: this.statuses });
    }
}
